import React from 'react';
import { View, Modal as RNModal, Pressable } from 'react-native';
import { useThemedStyles } from '../../hooks/useThemedStyles';

// Web-compatible modal that doesn't have ref issues
const Modal = ({
	isVisible,
	onBackdropPress,
	onRequestClose,
	children,
	...props
}) => {
	const styles = useThemedStyles(createStyles);

	if (!isVisible) {
		return null;
	}

	return (
		<RNModal
			visible={isVisible}
			transparent={true}
			animationType="fade"
			// Escape closes the modal like a backdrop press unless the caller handles it.
			onRequestClose={onRequestClose || onBackdropPress}
			{...props}
		>
			<Pressable onPress={onBackdropPress} style={styles.backdrop}>
				{/* Keep dialog centered across mobile browsers even when wrappers stretch. */}
				<View style={styles.centerWrapper}>
					<Pressable onPress={(e) => e.stopPropagation()} style={styles.content}>
						{children}
					</Pressable>
				</View>
			</Pressable>
		</RNModal>
	);
};

const createStyles = ({ ui: { colors, radius } }) => ({
	backdrop: {
		flex: 1,
		backgroundColor: colors.overlay,
		justifyContent: 'center',
		alignItems: 'center',
	},
	centerWrapper: {
		flex: 1,
		width: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		paddingHorizontal: 12,
	},
	content: {
		backgroundColor: 'transparent',
		borderRadius: radius.hero,
		maxHeight: '90%',
		maxWidth: '90%',
	},
});

export default Modal;
